import React from 'react';
import PatientQueue from './PatientQueue';

const PatientServicesQueue = () =>
	<PatientQueue
		showQueueCount
		supportDetailColumn
		providerDetailColumn
		patientDetailColumn
		showSupportReason
		programTypeColumn
		showPatientServicesProgramTypeFilter
		showLanguageFilter
		chartColumn
		lastWorkedByColumn
		queue="patientServices"
		endpoint="Support"
		label="Patient Services"
	/>;

export default PatientServicesQueue;
